import React from 'react';
import {useTheme} from '@mui/material';
import {TagChip} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';

const {onDemand} = translations['pt-br'].privateFlow.bookingFlow.examSelection;

export function OnDemandExamsChip() {
	const theme = useTheme();

	return (
		<TagChip
			label={onDemand.tagText}
			color="success"
			icon={
				<Icon
					name="calendar-focused-filled"
					size={18}
					color={theme.palette.success.light}
				/>
			}
			sx={{
				px: 1,
			}}
		/>
	);
}
